import SpeedIcon from '@mui/icons-material/ShutterSpeed';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import NoShipmentsYet from '../NoShipmentsYet/NoShipmentsYet';
import useFastestDeliveries from './useFastestDeliveries';

const FastestDeliveries = () => {
  const hook = useFastestDeliveries();
  return (
    <Card sx={{ p: 3, borderRadius: 3, boxShadow: 2, height: '100%' }}>
      <Typography variant="body1" sx={{ fontWeight: 600, mb: '1rem' }}>
        Récord de entregas más rápidas
      </Typography>
      <Box display="flex" alignItems="center" justifyContent="space-around">
        {hook.data.data?.length === 0 ? (
          <NoShipmentsYet />
        ) : (
          <>
            <Box display="flex" alignItems="center" flexDirection="column" gap={2} sx={{ mb: 2 }}>
              <Box
                sx={{
                  width: 80,
                  height: 80,
                  borderRadius: '50%',
                  bgcolor: 'primary.main',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <SpeedIcon sx={{ fontSize: 50, color: 'white' }} />
              </Box>

              <Box textAlign="center">
                <Typography variant="h5" fontWeight="bold">
                  {hook.data?.record?.durationMin}
                </Typography>
                <Typography color="textSecondary">{hook.data?.record?.deliveredAt}</Typography>
                <Typography variant="body2" color="textSecondary">
                  {hook.data?.record?.trackingId}
                </Typography>
              </Box>
            </Box>

            <Stack spacing={1}>
              {hook.data?.data?.map((delivery, index) => (
                <Card key={index} variant="outlined" sx={{ borderRadius: 2 }}>
                  <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 1, p: 1.5 }}>
                    <SpeedIcon color="primary" />
                    <Box>
                      <Typography fontWeight="bold">
                        {delivery.durationMin} | {delivery.deliveredAt}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        {delivery.trackingId}
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              ))}
            </Stack>
          </>
        )}
      </Box>
    </Card>
  );
};

export default FastestDeliveries;
